 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

import SendClientSideEvent from '../../utils/SendClientSideEvent'
import getValidRedirectParam from '../../utils/getValidRedirectParam'






const handleAuthenticationRedirect


 = (
  acceptTeamInvitation,
  {meetingId: locallyRequestedMeetingId, history, atmosphere, redirectPath = '/meetings'}
) => {
  SendClientSideEvent(atmosphere, 'User Login')
  const redirectTo = getValidRedirectParam()
  if (redirectTo) {
    history.push(redirectTo)
    return
  }
  if (!_optionalChain([acceptTeamInvitation, 'optionalAccess', _ => _.team])) {
    history.push(redirectPath)
    return
  }
  const {meetingId: invitedMeetingId, team} = acceptTeamInvitation
  const {id: teamId, activeMeetings} = team
  const meetingId = locallyRequestedMeetingId || invitedMeetingId
  const activeMeeting =
    (meetingId && activeMeetings.find((meeting) => meeting.id === meetingId)) || activeMeetings[0]
  if (activeMeeting) {
    history.push(`/meet/${activeMeeting.id}`)
  } else {
    history.push(`/team/${teamId}`)
  }
}
export default handleAuthenticationRedirect
